import React from 'react';
import { Shield, Zap, Award, HeadphonesIcon, FileCheck, TrendingUp, ArrowRight } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';

const Benefits = ({ onBookInspection }) => {
  const { formatPrice, t } = useCurrency();
  
  const benefits = [
    { icon: FileCheck, title: t('benefits.items.check.title'), stat: t('benefits.items.check.stat'), desc: t('benefits.items.check.desc') },
    { icon: Zap, title: t('benefits.items.report.title'), stat: t('benefits.items.report.stat'), desc: t('benefits.items.report.desc') },
    { icon: Shield, title: t('benefits.items.warranty.title'), stat: t('benefits.items.warranty.stat'), desc: t('benefits.items.warranty.desc') },
    { icon: TrendingUp, title: t('benefits.items.loans.title'), stat: t('benefits.items.loans.stat'), desc: t('benefits.items.loans.desc') },
    { icon: Award, title: t('benefits.items.digital.title'), stat: t('benefits.items.digital.stat'), desc: t('benefits.items.digital.desc') },
    { icon: HeadphonesIcon, title: t('benefits.items.support.title'), stat: t('benefits.items.support.stat'), desc: t('benefits.items.support.desc') },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900" style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
            {t('benefits.why')} <span className="text-blue-600">Wisedrive</span>
          </h2>
          <p className="text-slate-600 mt-2">{t('benefits.smartChoice')}</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-12">
          {benefits.map((item, index) => (
            <div key={index} className="text-center p-4 bg-slate-50 rounded-2xl hover:bg-blue-50 transition-colors group">
              <item.icon className="h-8 w-8 text-blue-600 mx-auto mb-3 group-hover:scale-110 transition-transform" />
              <div className="text-2xl font-bold text-slate-900 mb-1">{item.stat}</div>
              <div className="text-xs text-slate-500">{item.desc}</div>
              <div className="text-sm font-semibold text-slate-700 mt-2">{item.title}</div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl p-8 text-center text-white">
          <h3 className="text-2xl font-bold mb-2">{t('benefits.ctaTitle')}</h3>
          <p className="text-slate-300 text-sm">
            {t('benefits.ctaDesc', { amount: formatPrice(45000) })}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
